import React from "react";
import { Helmet } from "react-helmet";

export interface PageSEOProps {
  canonical?: string;
  description?: string;
  noIndex?: boolean;
  image?: string;
  title?: string;
  type?: string;
}

const PageSEO: React.FC<PageSEOProps> = ({
  canonical,
  description,
  noIndex,
  image,
  title,
  type
}) => {
  // warn against violating best practices
  if (title && title.length > 70) {
    console.warn(
      `SEO WARNING: The title of the page is longer than 70 characters`
    );
  }
  if (description && description.length > 160) {
    console.warn(
      `SEO WARNING: The description of the page is longer than 160 characters`
    );
  }
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {title && <meta property="og:title" content={title} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      {description && <meta name="keywords" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {type && <meta property="og:type" content={type} />}
      {image && <meta name="twitter:image" content={image} />}
      {image && <meta property="og:image" content={image} />}
      {image && <meta name="twitter:card" content={image} />}
      {noIndex && <meta name="robots" content="noindex" />}
      {noIndex && <meta name="googlebot" content="noindex" />}
    </Helmet>
  );
};

export default PageSEO;
